import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";
import { API_BASE_URI } from "../ApiCall";
import { MiscExpenseActionTypes } from "./MiscExpense.type";

export function* fetchAllMiscExpenses(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/misc-expense?project_id=${action.payload?.project_id}`
    );
    yield put({ type: MiscExpenseActionTypes.FETCH_ALL_MISC_EXPENSE_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: MiscExpenseActionTypes.FETCH_ALL_MISC_EXPENSE_FAILURE, payload: error });
  }
}

export function* fetchOneMiscExpenses(action: any): any {
  try {
    const response = yield axios.get(`${API_BASE_URI}/misc-expense/${action.payload}`);
    yield put({ type: MiscExpenseActionTypes.FETCH_ONE_MISC_EXPENSE_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: MiscExpenseActionTypes.FETCH_ONE_MISC_EXPENSE_FAILURE, payload: error });
  }
}

export function* watcherFetchAllMiscExpenses() {
  yield takeLatest(MiscExpenseActionTypes.FETCH_ALL_MISC_EXPENSE, fetchAllMiscExpenses);
}

export function* watcherFetchOneMiscExpenses() {
  yield takeLatest(MiscExpenseActionTypes.FETCH_ONE_MISC_EXPENSE, fetchOneMiscExpenses);
}
